<div class="dialog">
  <div class="header">
    <div class="title">
      @if (isListView()) {
        Indexes
      } @else {
        Add Index
      }
    </div>
    <button
      matDialogClose
      blazeIconButton
      class="close"
      (click)="closeDialog()"
      data-cy="Dialog:close"
    >
      <mat-icon svgIcon="close" />
    </button>
  </div>

  <div class="content">
    <ng-container *ngTemplateOutlet="isListView() ? indexes : addIndex" />
  </div>

  <div class="action">
    @if (isListView()) {
      <button blazeButton [disabled]="disableAction()" (click)="isListView.set(false)"
        >Add new</button
      >
    } @else {
      <button blazeButton [disabled]="disableAction()" (click)="create()">Create</button>
    }
  </div>
</div>

<ng-template #indexes>
  @if (compoundIndexes.length) {
    <div class="indexes-list">
      @for (compoundIndex of compoundIndexes; track compoundIndex.name) {
        <div class="index-section group">
          <div class="columns-list">
            @for (column of compoundIndex.columns; track column.columnName; let i = $index) {
              <blaze-checkbox [checked]="true" [disabled]="true">
                {{ column.columnName }}
              </blaze-checkbox>
            }
          </div>
          <button
            class="invisible group-hover:visible"
            blazeIconButton
            (click)="deleteIndex(compoundIndex.name)"
          >
            <mat-icon svgIcon="icon_trash_24" />
          </button>
        </div>
      }
    </div>
  }
</ng-template>

<ng-template #addIndex>
  @let columns = columns$ | async;
  <div class="text-11 text-primary mb-16">
    Improves performance for filtering and sorting by exact values or ranges. Best for IDs, dates,
    or numbers.
  </div>
  <div class="section" [formGroup]="form">
    @if (columns?.length) {
      <ng-container formArrayName="columns">
        @for (column of columnControls; track column; let index = $index) {
          <div class="column-to-select group" [formGroup]="column">
            @let control = column.value;
            <blaze-checkbox formControlName="selected">
              {{ control.columnName }}
            </blaze-checkbox>
            @let direction = control.direction;
            <button
              class="invisible group-hover:visible"
              blazeIconButton
              [blazeTooltip]="direction"
              (click)="switchDirection(index)"
            >
              <mat-icon
                [svgIcon]="
                  direction === 'Ascending' ? 'icon_direction_up_24' : 'icon_direction_down_24'
                "
              />
            </button>
          </div>
        }
      </ng-container>
    }
  </div>
</ng-template>
